import React from 'react'
import { useNavigate } from 'react-router-dom'
import '../css/general/SubHeader.css'

const SubHeader = ({ message }) => {
    const navigate = useNavigate();

  return (
    <>
                  <section className='subheader-bg'>
                <div className='container py-5'>

                    <p className='banner-heading col-lg-6 col-md-8'>{message}</p>
                    <p className='col-lg-5 col-md-8 fw-semibold'><span className='cursor-pointer' onClick={() => navigate('/')}>
                        Home</span><i class="fa-solid fa-angle-right px-2"></i>{message}</p>

                </div>
            </section>
    </>
  )
}

export default SubHeader
